import moment from 'moment'
import { useQuery } from 'react-query'
import Spinner from '../../../../components/Spinner/Spinner'
import { getTotalUser } from '../../../../models/statistics'

import MonthlyUsersChart from "./MonthlyUsersChart"


const MonthlyUsersCard = () => {
    const { isLoading, isError, data: { data } = {} } = useQuery('statistic-total-user-current-month', () => getTotalUser({
        startPubDate: moment().startOf('month').format('YYYYMMDD'),
        endPubDate: moment().format('YYYYMMDD')
    }))

    return (
        <div className="card">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <p className="mb-0 fs-3 fw-bold text-gray-800">Users</p>
                        <p className="mb-0 text-gray-400 fw-semibold">{moment().startOf('month').format('MMM DD')} - {moment().format('MMM DD YYYY')}</p>
                    </div>
                    {isLoading ? <Spinner color="success" /> : !isError ? (
                        <p className="mb-0 fw-bold fs-3 text-success">+{data.total_user}</p>
                    ) : null}
                </div>
            </div>
            <div className="h-200px">
                <MonthlyUsersChart />
            </div>
        </div>
    )
}

export default MonthlyUsersCard